import { HttpErrorService } from '@/services/HttpError.service'
import { newsErrorHandbook } from '@/models/Errors'
import type { NewsPageKit } from '@/models'
import { HttpService } from '@/services/Http.service'

export class NewsPageKitService {
  private httpErrorService: HttpErrorService<keyof typeof newsErrorHandbook>
  private endpoint = '/news-page-kit/'
  private httpService: HttpService

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(
      newsErrorHandbook,
      'news-page-kits',
    )
  }

  async getById(id: number | string) {
    const url = [this.endpoint, id].join('')

    return await this.httpService
      .get<NewsPageKit>(url, {
        fetchConfig: { timeout: 10000 },
        requestConfig: {
          cancellable: true,
          needCancelAtChangeRoute: true,
          forceRequest: true,
          needGlobal404: true,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }
}
